import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

class DraftHelper {
    static getContentAsEditorState(content: string) {
        if (content === undefined || content === null || content.length === 0) {
            return this.getEmptyEditorState();
        }

        let jsonContent = JSON.parse(content);
        
        return EditorState.createWithContent(convertFromRaw(jsonContent));
    }

    static getEmptyEditorState() {
        return EditorState.createEmpty();
    }

    static getEditorStateAsJson(editorState: EditorState): string {
        let raw = convertToRaw(editorState.getCurrentContent());
        return JSON.stringify(raw);
    }

    static getEditorStateAsHtml(editorState: EditorState): string {
        return draftToHtml(convertToRaw(editorState.getCurrentContent()));
    }
}

export default DraftHelper;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/DraftHelper.ts